import { createReducer, on } from "@ngrx/store";
import { DeviceCategoryStateInterface } from "src/app/devices/models/deviceCategoryStateInterface";
import * as Actions from "./actions";

export const initialState: DeviceCategoryStateInterface = {
    isLoading: false,
    deviceCategories: [],
    error: null,
};

export const deviceCategoriesReducers = createReducer(
    initialState, 

    // get Device Categories
    on(Actions.getDeviceCategories, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.getDeviceCategoriesSuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        deviceCategories: action.deviceCategories.slice().sort((a, b) => a.name.localeCompare(b.name))
    })),
    on(Actions.getDeviceCategoriesFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // create Device Categories
    on(Actions.createDeviceCategory, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.createDeviceCategorySuccess, (state, action) => ({
        ...state, 
        isLoading: false,
        deviceCategories: [...state.deviceCategories, action.deviceCategory].sort((a, b) => a.name.localeCompare(b.name))
    })),
    on(Actions.createDeviceCategoryFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // update Device Categories
    on(Actions.updateDeviceCategory, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.updateDeviceCategorySuccess, (state, action) => {
        const updatedCategoryIndex = state.deviceCategories.findIndex(category => category.id === action.deviceCategory.id);
        
        if (updatedCategoryIndex === -1) {
            return state; // If category not found, return current state
        }

        const updatedCategories = [...state.deviceCategories];
        updatedCategories[updatedCategoryIndex] = action.deviceCategory;

        return {
            ...state,
            isLoading: false,
            deviceCategories: updatedCategories.sort((a, b) => a.name.localeCompare(b.name))
        };
    }),
    on(Actions.updateDeviceCategoryFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // delete Device Categories
    on(Actions.deleteDeviceCategory, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.deleteDeviceCategorySuccess, (state,action) => ({
        ...state, 
        isLoading: false,
        deviceCategories: state.deviceCategories.filter(category => category.id !== action.id)
      })),
    on(Actions.deleteDeviceCategoryFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),
);